import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Review {
  name: string;
  role: string;
  image: string;
  quote: string;
  rating: number;
}
export function ReviewsSection() {
  const initialReviews: Review[] = [{
    name: 'Laura M.',
    role: 'Profesora de Historia',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    quote: 'El año pasado estaba completamente agotada. Cuando encontré esta colección sentí un alivio enorme. Tenía actividades y presentaciones listas.',
    rating: 5
  }, {
    name: 'Diego R.',
    role: 'Docente de secundaria',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    quote: 'Tener análisis de fuentes y ejercicios listos me permitió enfocarme más en trabajar con los estudiantes y menos en inventar materiales.',
    rating: 5
  }, {
    name: 'Mariana G.',
    role: 'Profesora de Historia',
    image: 'https://randomuser.me/api/portraits/women/68.jpg',
    quote: 'Fue la primera vez en años que comencé el ciclo lectivo con la sensación de tener casi todo organizado. Me dio mucha tranquilidad.',
    rating: 5
  }, {
    name: 'Carlos A.',
    role: 'Profesor de Historia',
    image: 'https://randomuser.me/api/portraits/men/52.jpg',
    quote: 'Llevo 15 años dando clases y nunca había encontrado un material tan completo. Las planificaciones me ahorraron semanas de trabajo.',
    rating: 5
  }, {
    name: 'Valentina S.',
    role: 'Docente de secundaria',
    image: 'https://randomuser.me/api/portraits/women/26.jpg',
    quote: 'Las diapositivas son excelentes. Mis alumnos están mucho más atentos en clase desde que las uso.',
    rating: 5
  }];
  const [reviews, setReviews] = useState<Review[]>(initialReviews);
  const [newName, setNewName] = useState('');
  const [newQuote, setNewQuote] = useState('');
  const [newRating, setNewRating] = useState(5);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (newName.trim() && newQuote.trim()) {
      setReviews([{
        name: newName,
        role: 'Docente',
        image: `https://ui-avatars.com/api/?name=${encodeURIComponent(newName)}&background=586880&color=fff`,
        quote: newQuote,
        rating: newRating
      }, ...reviews]);
      setSubmitted(true);
      setNewName('');
      setNewQuote('');
      setNewRating(5);
      setTimeout(() => setSubmitted(false), 3000);
    }
  };
  return <section className="bg-[#F4F4F2] py-10 px-4 border-t border-[#E2DED6]" data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-[#424E60] uppercase text-center mb-8" data-id="element-158">
          TODAS LAS RESEÑAS DE NUESTROS DOCENTES
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10" data-id="element-159">
          {reviews.map((review, index) => <motion.div key={`${review.name}-${index}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-lg p-5 shadow-sm border-l-4 border-[#586880] flex flex-col h-full" data-id="element-160">
              <div className="flex items-center gap-3 mb-3" data-id="element-161">
                <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover" data-id="element-162" />
                <div data-id="element-163">
                  <h4 className="font-bold text-[#424E60] text-sm leading-tight" data-id="element-164">
                    {review.name}
                  </h4>
                  <p className="text-[#586880] text-xs" data-id="element-165">{review.role}</p>
                </div>
                <div className="flex text-yellow-500 ml-auto" data-id="element-166">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} fill={i < review.rating ? 'currentColor' : 'none'} className={i >= review.rating ? 'text-gray-300' : ''} data-id="element-167" />)}
                </div>
              </div>
              <p className="text-[#424E60] text-sm italic leading-relaxed flex-grow" data-id="element-168">
                "{review.quote}"
              </p>
            </motion.div>)}
        </div>

        {/* Review Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-xl mx-auto bg-white rounded-xl p-6 shadow-md border border-[#E2DED6]" data-id="element-169">
          <h3 className="text-xl font-bold text-[#424E60] mb-4 text-center" data-id="element-170">
            ¿Ya adquiriste el manual? ¡Dejá tu reseña!
          </h3>

          {submitted ? <div className="bg-green-50 text-green-700 p-4 rounded-lg text-center font-medium" data-id="element-171">
              ¡Gracias por tu reseña! Ha sido publicada con éxito.
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-172">
              <div data-id="element-173">
                <input type="text" required placeholder="Tu nombre" value={newName} onChange={e => setNewName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C59] focus:border-transparent outline-none" data-id="element-174" />
              </div>

              <div className="flex items-center gap-2" data-id="element-175">
                <span className="text-sm text-gray-600" data-id="element-176">Calificación:</span>
                <div className="flex gap-1" data-id="element-177">
                  {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setNewRating(star)} className="focus:outline-none" data-id="element-178">
                      <Star size={20} fill={star <= newRating ? '#EAB308' : 'none'} className={star <= newRating ? 'text-yellow-500' : 'text-gray-300'} data-id="element-179" />
                    </button>)}
                </div>
              </div>

              <div data-id="element-180">
                <textarea required placeholder="Contanos tu experiencia..." rows={3} value={newQuote} onChange={e => setNewQuote(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C59] focus:border-transparent outline-none resize-none" data-id="element-181" />
              </div>

              <button type="submit" className="w-full bg-[#4A7C59] text-white font-bold py-2 px-4 rounded-lg hover:bg-[#3D6B4A] transition-colors" data-id="element-182">
                Publicar reseña
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}